export interface ILoginResult {
    companyId: string;
    companyName: string;
    name: string;
    code: string;
    picture: string;
    canUseMessages: boolean;
    canUseDocuments: boolean;
    canUseEvents: boolean;
    canUseTasks: boolean;
    canUseInstantMessages: boolean;
    canEditOwnRecord: boolean;
    canUseCalendarTasks: boolean;
    canUseMultipleCompanies: boolean;
}

export class LoginResult implements ILoginResult {
    companyId: string;
    companyName: string;
    name: string;
    code: string;
    picture: string;
    canUseMessages: boolean;
    canUseDocuments: boolean;
    canUseEvents: boolean;
    canUseTasks: boolean;
    canUseInstantMessages: boolean;
    canEditOwnRecord: boolean;
    canUseCalendarTasks: boolean;
    canUseMultipleCompanies: boolean;

    constructor();
    constructor(obj: ILoginResult);
    constructor(obj?: any) {
        this.companyId = obj && obj.companyId || "";
        this.companyName = obj && obj.companyName || "";
        this.name = obj && obj.name || "";
        this.code = obj && obj.code || "";
        this.picture = obj && obj.picture || "";
        this.canUseMessages = obj && obj.canUseMessages || false;
        this.canUseDocuments = obj && obj.canUseDocuments || false;
        this.canUseEvents = obj && obj.canUseEvents || false;
        this.canUseTasks = obj && obj.canUseTasks || false;
        this.canUseInstantMessages = obj && obj.canUseInstantMessages || false;
        this.canEditOwnRecord = obj && obj.canEditOwnRecord || false;
        this.canUseCalendarTasks = obj && obj.canUseCalendarTasks || false;
        this.canUseMultipleCompanies = obj && obj.canUseMultipleCompanies || false;
    }
}